import { createBrowserRouter } from 'react-router-dom';

import { AppShell } from '@/components/layout/AppShell';
import { AcceptInvitePage } from '@/pages/AcceptInvitePage';
import { AdminPage } from '@/pages/AdminPage';
import { BomDetailPage } from '@/pages/BomDetailPage';
import { BomImportPage } from '@/pages/BomImportPage';
import { BomsPage } from '@/pages/BomsPage';
import { CreateOrgPage } from '@/pages/CreateOrgPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { ImportPartsPage } from '@/pages/ImportPartsPage';
import { LocationsPage } from '@/pages/LocationsPage';
import { LoginPage } from '@/pages/LoginPage';
import { OrganizationPage } from '@/pages/OrganizationPage';
import { PartsPage } from '@/pages/PartsPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { RequestAccountPage } from '@/pages/RequestAccountPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { SignupPage } from '@/pages/SignupPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/signup', element: <SignupPage /> },
  { path: '/request-account', element: <RequestAccountPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/accept-invite', element: <AcceptInvitePage /> },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'parts', element: <PartsPage /> },
      { path: 'parts/import', element: <ImportPartsPage /> },
      { path: 'boms', element: <BomsPage /> },
      { path: 'boms/:bomId', element: <BomDetailPage /> },
      { path: 'boms/:bomId/import', element: <BomImportPage /> },
      { path: 'locations', element: <LocationsPage /> },
      { path: 'orgs/new', element: <CreateOrgPage /> },
      { path: 'orgs/:orgSlug', element: <OrganizationPage /> },
      { path: 'admin', element: <AdminPage /> },
      { path: 'profile', element: <ProfilePage /> },
    ],
  },
]);
